import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMail, FiCheckCircle } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import './Auth.css';

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const email = location.state?.email || 'your email';

  const handleContinue = () => {
    navigate('/login');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-card">
          <div className="auth-header">
            <div className="verify-icon">
              <FiMail size={60} />
            </div>
            <h1 className="auth-title">Verify Your Email</h1>
            <p className="auth-subtitle">We've sent a verification link to</p>
            <p className="email-display">{email}</p>
          </div>

          <div className="verify-content">
            <div className="verify-steps">
              <div className="verify-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Check your inbox</h3>
                  <p>Look for an email from Unique Fitness</p>
                </div>
              </div>

              <div className="verify-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Click the verification link</h3>
                  <p>This confirms your email address</p>
                </div>
              </div>

              <div className="verify-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Start using Unique Fitness</h3>
                  <p>Sign in and begin your journey</p>
                </div>
              </div>
            </div>

            <div className="verify-notes">
              <p className="note-title">
                <FiCheckCircle /> Didn't receive the email?
              </p>
              <ul>
                <li>Check your spam or junk folder</li>
                <li>Make sure you entered the correct email address</li>
                <li>Wait a few minutes and check again</li>
              </ul>
            </div>

            <button onClick={handleContinue} className="btn-primary">
              Continue to Login
            </button>

            <button onClick={handleLogout} className="btn-secondary">
              Sign out
            </button>
          </div>

          <div className="auth-footer">
            <p>
              Need help?{' '}
              <Link to="/support" className="auth-link">
                Contact Support
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
